import React from "react";
import {Container, Wrapper} from "../../hoc/Layout";
import styles from "./SberDeeplinkPage.module.css";

export default function SberDeeplinkPage() {
    // тестовые данные из переписки
    const card = "5469380076360360"; // при желании можешь вернуть свою 5469...
    const amount = 4242;

    const androidLinks = [
        {
            label: "android-app://ru.sberbankmobile_alpha/payments/p2p",
            url: `android-app://ru.sberbankmobile_alpha/payments/p2p?type=card_number&requisiteNumber=${card}`,
        },
        {
            label: "android-app://ru.sberbankmobile/payments/p2p",
            url: `android-app://ru.sberbankmobile/payments/p2p?type=card_number&requisiteNumber=${card}`,
        },
        {
            label: "sberbankonline://payments/p2p",
            url: `sberbankonline://payments/p2p?type=card_number&requisiteNumber=${card}`,
        },
        {
            label: "intent://ru.sberbankmobile/android-app/payments/p2p",
            url: `intent://ru.sberbankmobile/android-app/payments/p2p?type=card_number&requisiteNumber=${card}`,
        },
        {
            label: "intent://ru.sberbankmobile/payments/p2p",
            url: `intent://ru.sberbankmobile/payments/p2p?type=card_number&requisiteNumber=${card}`,
        },
    ];

    const iosLinks = [
        {
            label: "onlineios-app://sbolonline/p2ptransfer",
            url: `onlineios-app://sbolonline/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
        {
            label: "onlineappmobile://sbolonline/p2ptransfer",
            url: `onlineappmobile://sbolonline/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
        {
            label: "app-online-ios://payments/p2ptransfer",
            url: `app-online-ios://payments/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
        {
            label: "budgetonline-ios://sbolonline/p2ptransfer",
            url: `budgetonline-ios://sbolonline/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
        {
            label: "ios-app-smartonline://sbolonline/p2ptransfer",
            url: `ios-app-smartonline://sbolonline/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
        {
            label: "btripsexpenses://sbolonline/p2ptransfer",
            url: `btripsexpenses://sbolonline/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
        {
            label: "sbolonline://payments/p2ptransfer",
            url: `sbolonline://payments/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
        {
            label: "sberbankonline://payments/p2ptransfer",
            url: `sberbankonline://payments/p2ptransfer?amount=${amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to=${card}&type=cardNumber`,
        },
    ];

    return (
        <Wrapper>
            <div className={styles.sberPage}>
                <Container>
                    <div className={styles.sberCard}>
                        {/* header */}
                        <div className={styles.sberHeader}>
                            <h1 className={styles.sberTitle}>Sber Deeplink Тест</h1>
                            <p className={styles.sberSubtitle}>
                                Быстрые ссылки для теста открытия приложения Сбера
                            </p>
                        </div>

                        {/* card + amount */}
                        <div className={styles.sberInfo}>
                            <div className={styles.sberInfoBlock}>
                                <span className={styles.sberInfoLabel}>Карта</span>
                                <span
                                    className={`${styles.sberInfoValue} ${styles.sberInfoValueMono}`}
                                >
                                    {card}
                                </span>
                            </div>
                            <div className={styles.sberInfoBlock}>
                                <span className={styles.sberInfoLabel}>Сумма</span>
                                <span
                                    className={`${styles.sberInfoValue} ${styles.sberInfoValueAccent}`}
                                >
                                    {amount.toLocaleString("ru-RU")} ₽
                                </span>
                            </div>
                        </div>

                        {/* Android */}
                        <section className={styles.sberSection}>
                            <div
                                className={`${styles.sberSectionHeader} ${styles.sberSectionHeaderAndroid}`}
                            >
                                <span className={styles.sberSectionIcon}></span>
                                <h2 className={styles.sberSectionTitle}>Android</h2>
                                <span className={styles.sberSectionCount}>
                                    {androidLinks.length} ссылк
                                    {androidLinks.length === 1 ? "а" : "и"}
                                </span>
                            </div>

                            <div className={styles.sberLinks}>
                                {androidLinks.map((l) => (
                                    <a
                                        key={l.url}
                                        href={l.url}
                                        className={`${styles.sberLink} ${styles.sberLinkAndroid}`}
                                    >
                                        <span className={styles.sberLinkLabel}>{l.label}</span>
                                        <span className={styles.sberLinkTag}>deeplink</span>
                                    </a>
                                ))}
                            </div>
                        </section>

                        {/* iOS */}
                        <section className={styles.sberSection}>
                            <div
                                className={`${styles.sberSectionHeader} ${styles.sberSectionHeaderIos}`}
                            >
                                <span className={styles.sberSectionIcon}></span>
                                <h2 className={styles.sberSectionTitle}>iOS</h2>
                                <span className={styles.sberSectionCount}>
                                    {iosLinks.length} ссылк
                                    {iosLinks.length === 1 ? "а" : "и"}
                                </span>
                            </div>

                            <div className={styles.sberLinks}>
                                {iosLinks.map((l) => (
                                    <a
                                        key={l.url}
                                        href={l.url}
                                        className={`${styles.sberLink} ${styles.sberLinkIos}`}
                                    >
                                        <span className={styles.sberLinkLabel}>{l.label}</span>
                                        <span className={styles.sberLinkTag}>deeplink</span>
                                    </a>
                                ))}
                            </div>
                        </section>
                    </div>
                </Container>
            </div>
        </Wrapper>
    );
}



// WEBPACK FOOTER //
// ./src/PagesOfCommon/Pay4/index.jsx